import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AddProject } from 'components/forms';
import { getClientList } from 'store/clientSlice';

export default function AddProjectPage() {
	const dispatch = useDispatch();
	const [clientsData, setClientsdata] = useState('');
	const [formData, setFormData] = useState({});
	const { id } = useParams();
	console.log(id);
	useEffect(() => {
		if (id) {
			dispatch(
				getClientList({
					search_type: 'project',
					filter_by: {
						id,
					},
				})
			).then((res) => {
				setFormData(res?.data?.[0]);
			});
		}

		dispatch(
			getClientList({
				search_type: 'client',
				filter_by: {},
			})
		)
			.then((res) => {
				const data = res?.data?.map((item) => ({
					value: item?.id,
					label: item?.client_info?.client_name,
					item,
				}));
				setClientsdata(data);
			})
			.finally(() => {});
	}, [dispatch, id]);

	return <AddProject clientsData={clientsData} isEditMode={Boolean(id)} formData={formData} />;
}
